export default "__VITE_ASSET__BcgoZtFu__"